module.exports = __webpack_public_path__ + "img/erro404.1c8097c4.png";